export const services=[

{
name:"Magyne Platform",
status:"Operational"
},

{
name:"Authentication Service",
status:"Operational"
},

{
name:"Carwash Pro",
status:"Operational"
},

{
name:"School Admin",
status:"Operational"
},

{
name:"API Services",
status:"Operational"
}

];